export default __webpack_public_path__ + "static/media/splash-background.285e6798.svg";